export const paymentMethods = [
  {
    name: 'Card',
    type: 'card',
    icon: require('@/assets/img/icons/billing/credit-card.png')
  },
  {
    name: 'Apple pay',
    type: 'apple-pay',
    icon: require('@/assets/img/icons/billing/apple-pay.png')
  },
  {
    name: 'Google pay',
    type: 'google-pay',
    icon: require('@/assets/img/icons/billing/google-pay.png')
  },
  {
    name: 'PayPal',
    type: 'paypal',
    icon: require('@/assets/img/icons/billing/paypal.png')
  }
]
